import { useMemo, useState } from 'react';

import {
  ChakraBox,
  MultiSelectOption,
  Text,
  UniversalSelect,
} from '@equip.health/ui';

import { EMPTY_PLACEHOLDER } from '~/components/maud/patients/treatmentEpisode/Types';
import { dropdownMenuOptionsMapper } from '~/lib/util/inquiry.util';

export interface UniversalSelectTextViewProps {
  id: string;
  isClearable?: boolean;
  isReadOnly: boolean;
  onChange: (newValue: string | null) => void;
  options: string[];
  value: string;
}

const UniversalSelectTextView = ({
  id,
  isClearable = true,
  isReadOnly,
  options,
  onChange,
  value,
}: UniversalSelectTextViewProps) => {
  const dropdownOptions: MultiSelectOption[] = useMemo<MultiSelectOption[]>(
    () => dropdownMenuOptionsMapper(options),
    [options],
  );
  const [currentValue, setCurrentValue] = useState<string>(value);

  const selectedOption = useMemo<MultiSelectOption | undefined>(() => {
    return (dropdownOptions ?? []).find((o) => o.value === currentValue);
  }, [dropdownOptions, currentValue]);

  const handleChange = (newValue: string | null) => {
    setCurrentValue(newValue);
    onChange(newValue);
  };

  return (
    <ChakraBox>
      {isReadOnly ? (
        <Text
          color={currentValue ? 'neutral.primary' : 'neutral.tertiary'}
          id={id}
        >
          {currentValue || EMPTY_PLACEHOLDER}
        </Text>
      ) : (
        <UniversalSelect
          id={`${id}__edit`}
          isClearable={isClearable}
          isSingleSelect
          onChange={(value) => handleChange(value?.value)}
          options={dropdownOptions}
          value={selectedOption}
        />
      )}
    </ChakraBox>
  );
};

export default UniversalSelectTextView;
